"use strict";

exports.__esModule = true;
exports.DsStepper = void 0;

require("core-js/modules/es.array.map.js");

require("./DsStepper.css");

var _jsxRuntime = require("react/jsx-runtime");

var DsStepper = function DsStepper(_ref) {
  var stepIndex = _ref.stepIndex,
      items = _ref.items;

  var getStepperStatus = function getStepperStatus(index) {
    if (stepIndex > index) {
      return 'fill';
    }

    if (index == stepIndex) {
      return 'current';
    }

    return 'inactive';
  };

  var getIcon = function getIcon(index) {
    if (stepIndex > index) {
      return 'check';
    }

    if (index == stepIndex) {
      return 'fiber_manual_record';
    }

    return '';
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: 'ds-stepper',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: 'track track--left'
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: 'track track--right'
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: 'container',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: 'stepper text-primary',
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
            className: "stepper-step " + getStepperStatus(index),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: 'stepper-step-inner',
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: 'stepper-indicator',
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: 'icon',
                  children: getIcon(index)
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: 'stepper-label',
              children: item.label
            })]
          }, index);
        })
      })
    })]
  });
};

exports.DsStepper = DsStepper;